angular.module('impactx.displayelements').directive('ixCLOutput', function () {
    return {
        scope: {
            label : '@',
            data : '@'
        },
        restrict:'E',
        templateUrl: './shared/displayelements/templates/columnlabeloutput.html',
        transclude:true
    };
});